import React from "react";

const ProfileCard = () => {
  return (
    <div className="card">
      <img
        className="avatar"
        src="https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/home/25.png"
        alt="Profile"
      />
      <h2 className="name">Ash Ketchum</h2>
      <p className="occupation">Pokémon Trainer</p>
      <p className="bio">
        Aspiring Pokémon Master. Always ready for a battle! ⚡
      </p>
      <div className="socials">
        <a href="#ros" className="icon">
          🔵
        </a>{" "}
        {/* LinkedIn */}
        <a href="#ra" className="icon">
          🐦
        </a>{" "}
        {/* Twitter */}
        <a href="#res" className="icon">
          📸
        </a>{" "}
        {/* Instagram */}
        <a href="#pon" className="icon">
          🎮
        </a>{" "}
        {/* Twitch */}
      </div>
      <button className="contactButton">Catch 'em all!</button>
    </div>
  );
};

export default ProfileCard;
